import * as breakpoints from "../breakpoints";
import * as languages from "../constants/languages";
import { css, StyleSheet } from "aphrodite";
import { Column, Container, Row } from "../grid";
import FooterRow from "./FooterRow";
import { english, spanish } from "../constants/strings";
import Header from "./Header";
import { me } from "../api/account";
import { NotificationContainer } from "react-notifications";
import ProfileModal from "./ProfileModal";
import PropTypes from "prop-types";
import React, { PureComponent } from "react";

const styles = StyleSheet.create({
	contentContainer: {
		paddingBottom: 140, // these values are based on the height of the footer
		[breakpoints.mobileOnly]: {
			paddingBottom: 240,
		},
	},
	pageContainer: {
		minHeight: "100vh",
		position: "relative",
		"@media print": {
			maxHeight: 50,
			minHeight: 0,
			overflow: "hidden",
		},
	},
	pageContainerModalShowing: {
		maxHeight: "100vh",
		overflow: "hidden",
	},
	pageTitle: {
		marginTop: 55,
		marginBottom: 15,
		lineHeight: 0.92,
		fontSize: 60,
		fontWeight: 300,
		letterSpacing: 0.3,
		fontFamily: "PopulaireLight",
		[breakpoints.mobileOnly]: {
			marginTop: 28,
		},
		"@media print": {
			display: "none",
		},
	},
});

export default class Page extends PureComponent {
	static propTypes = {
		activeTab: PropTypes.string,
		children: PropTypes.object.isRequired,
		currentRoute: PropTypes.string.isRequired,
		language: PropTypes.string.isRequired,
		pageTitle: PropTypes.string,
		loggedIn: PropTypes.bool,
		modalShowing: PropTypes.bool,
	};

	constructor(props) {
		super(props);

		this.strings = props.language === languages.es ? spanish : english;

		this.state = {
			showProfileModal: false,
			currentEmail: "",
			txinLinked: null,
		};
	}

	componentDidMount() {
		me()
			.then(userInfo => {
				this.setState({
					currentEmail: userInfo.email,
					txinLinked: userInfo.txinLinked,
				});
			})
			.catch(err => {
				console.log(err);
			});
	}

	_dismissModal = () => {
		this.setState({
			showProfileModal: false,
		});
	};

	_profileClicked = () => {
		this.setState({
			showProfileModal: true,
		});
	};

	_updateEmail = currentEmail => {
		this.setState({
			currentEmail,
		});
	};

	render() {
		return (
			<div
				className={css([
					styles.pageContainer,
					this.state.showProfileModal || this.props.modalShowing
						? styles.pageContainerModalShowing
						: "",
				])}
			>
				<NotificationContainer />
				<a className="skip-main" href="#main">
					{this.strings.skipToContent}
				</a>
				<Header
					activeTab={this.props.activeTab}
					currentRoute={this.props.currentRoute}
					language={this.props.language}
					loggedIn={this.props.loggedIn}
					inApp={true}
					profileClicked={this._profileClicked}
				/>
				{this.props.pageTitle ? (
					<Container>
						<Row>
							<Column>
								<h1 className={css(styles.pageTitle)}>{this.props.pageTitle}</h1>
							</Column>
						</Row>
					</Container>
				) : null}
				<div id="main" className={css(styles.contentContainer)}>
					{this.props.children}
				</div>
				<ProfileModal
					currentEmailAddress={this.state.currentEmail}
					showing={this.state.showProfileModal}
					dismiss={this._dismissModal}
					language={this.props.language}
					updateEmail={this._updateEmail}
					txinLinked={this.state.txinLinked}
				/>
				<FooterRow language={this.props.language} />
			</div>
		);
	}
}



// WEBPACK FOOTER //
// ./src/components/Page.js